"use client";

import { BsXLg, BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { generateIcon } from "utils";
import type { Translationtype } from "utils";

interface IPaymentResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  success: boolean;
  t: Translationtype;
  onRetry?: () => void;
}

export function PaymentResultModal({
  isOpen,
  onClose,
  success,
  t,
  onRetry,
}: IPaymentResultModalProps) {
  if (!isOpen) {
    return null;
  }

  const handleRetry = () => {
    onClose();
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <dialog className="modal" open={isOpen}>
      <div className="modal-box max-w-lg w-full rounded-xl">
        <div className="modal-content relative z-20">
          <div className="w-full">
            <div className="flex items-center mb-4">
              <h1 className="text-2xl font-bold">
                {success ? t("Gallery.paymentSuccess") : t("Gallery.paymentCancelled")}
              </h1>
              <span
                className="ml-auto cursor-pointer"
                onClick={onClose}
              >
                {generateIcon(BsXLg, "h-[20px] w-[20px]")}
              </span>
            </div>

            <div className="flex flex-col items-center justify-center py-6">
              {success ? (
                <>
                  {generateIcon(BsCheckCircleFill, "h-[60px] w-[60px] text-green-500 mb-4")}
                  <p className="text-center mb-4">
                    {t("Gallery.aiGenerationStarted")}
                  </p>
                </>
              ) : (
                <>
                  {generateIcon(BsXCircleFill, "h-[60px] w-[60px] text-red-500 mb-4")}
                  <p className="text-center mb-4">
                    {t("Gallery.paymentCancelledMessage")}
                  </p>
                </>
              )}
            </div>

            <div className="flex gap-3 justify-end">
              {!success && onRetry && (
                <button
                  className="btn btn-primary"
                  onClick={handleRetry}
                  type="button"
                >
                  {t("Gallery.retryPayment")}
                </button>
              )}
              <button
                className="btn"
                onClick={onClose}
                type="button"
              >
                {success ? t("Buttons.ok") : t("Buttons.cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <form method="dialog" className="modal-backdrop">
        {/* eslint-disable-next-line */}
        <button onClick={onClose}>{t("Buttons.close")}</button>
      </form>
    </dialog>
  );
}
